import moment from "moment";
import PropTypes from "prop-types";
import React, { Component } from "react";
import DayPickerInput from "react-day-picker/DayPickerInput";
import MomentLocaleUtils, {
  formatDate,
  parseDate
} from "react-day-picker/moment";
import { connect } from "react-redux";
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import { Search } from "../../containers";
import { reloadErrorSongs } from "../../redux/actions/index";
import { ErrorSongService } from "../../services/errorSongService";
import StoreService from '../../services/storeService';


let errorSongService = new ErrorSongService();
let storeService = new StoreService();

const PHASE_LABELS = {
  PHASE_URL:       'URL',
  PHASE_ENQUEUE:   'Enqueue',
  PHASE_TRANSFER:  'Transferencia',
  PHASE_INTEGRITY: 'Integridad',
  PHASE_PLAYLIST:  'Playlist',
  PHASE_ORPHAN:    'Huérfano',
  PHASE_AUTH:      'Autenticación',
  PHASE_STARTUP:   'Startup',
  PHASE_CRASH:     'Crash',
  PHASE_PLAYBACK:  'Reproducción',
  PHASE_SYNC:      'Sincronización',
};

const PHASE_COLORS = {
  PHASE_URL:       '#6f42c1',
  PHASE_ENQUEUE:   '#fd7e14',
  PHASE_TRANSFER:  '#007bff',
  PHASE_INTEGRITY: '#dc3545',
  PHASE_PLAYLIST:  '#20c997',
  PHASE_ORPHAN:    '#6c757d',
  PHASE_AUTH:      '#e83e8c',
  PHASE_STARTUP:   '#795548',
  PHASE_CRASH:     '#b21f2d',
  PHASE_PLAYBACK:  '#0f6674',
  PHASE_SYNC:      '#2e7d32',
};

const ERROR_TYPE_LABELS = {
  ERR_AUTH:       'Auth',
  ERR_NOT_FOUND:  'No encontrado',
  ERR_NO_NETWORK: 'Sin red',
  ERR_SERVER:     'Servidor',
  ERR_CORRUPT:    'Corrupto',
  ERR_UNKNOWN:    'Desconocido',
  ERR_CRASH:      'Crash',
  ERR_PLAYBACK:   'Reproducción',
};

const ERROR_TYPE_COLORS = {
  ERR_AUTH:       '#ffc107',
  ERR_NOT_FOUND:  '#17a2b8',
  ERR_NO_NETWORK: '#6c757d',
  ERR_SERVER:     '#dc3545',
  ERR_CORRUPT:    '#dc3545',
  ERR_UNKNOWN:    '#adb5bd',
  ERR_CRASH:      '#b21f2d',
  ERR_PLAYBACK:   '#0f6674',
};

const badgeStyle = (color) => ({
  display: 'inline-block',
  padding: '2px 7px',
  borderRadius: '10px',
  fontSize: '11px',
  fontWeight: 600,
  color: '#fff',
  backgroundColor: color || '#adb5bd',
  whiteSpace: 'nowrap',
});

function fileName(path) {
  if (!path) return '-';
  return path.split('/').pop();
}

class TableHead extends Component {
  render() {
    return (
      <thead>
        <tr>
          <th>Tienda</th>
          <th>Versión</th>
          <th>Fase</th>
          <th>Tipo Error</th>
          <th>HTTP</th>
          <th>URL</th>
          <th>Origen</th>
          <th>Playlist</th>
          <th>Mensaje</th>
          <th>Reintentos</th>
          <th>Fecha</th>
          <th>Stack</th>
        </tr>
      </thead>
    );
  }
}


class ErrorSong extends Component {
  render() {
    let item = this.props.item;
    let store = storeService.Search(item.storeId);
    const phase = item.phase;
    const errorType = item.errorType;
    const msg = item.errorMessage || item.error || '-';
    const truncated = msg.length > 80 ? msg.substring(0, 80) + '…' : msg;
    const date = item.occurredAt || item.createdAt || item.computerTime;

    return (
      <tr>
        <td>{store.name || '-'}</td>
        <td style={{ whiteSpace: 'nowrap' }}>{item.appVersion || item.version || '-'}</td>
        <td>
          <span style={badgeStyle(PHASE_COLORS[phase])}>
            {PHASE_LABELS[phase] || phase || '-'}
          </span>
        </td>
        <td>
          <span style={badgeStyle(ERROR_TYPE_COLORS[errorType])}>
            {ERROR_TYPE_LABELS[errorType] || errorType || '-'}
          </span>
        </td>
        <td>{item.httpCode > 0 ? item.httpCode : '-'}</td>
        <td
          title={item.requestUrl}
          style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '11px', color: '#666' }}
        >
          {item.requestUrl ? item.requestUrl.replace(/^https?:\/\/[^/]+/, '') : '-'}
        </td>
        <td
          title={item.name}
          style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {fileName(item.name)}
        </td>
        <td style={{ maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {item.playlist || '-'}
        </td>
        <td title={msg} style={{ maxWidth: '260px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '12px', color: '#555' }}>
          {truncated}
        </td>
        <td style={{ textAlign: 'center' }}>
          {item.retryCount != null ? item.retryCount : '-'}
        </td>
        <td style={{ whiteSpace: 'nowrap' }}>
          {date ? moment(date).format("DD/MM/YY HH:mm") : '-'}
        </td>
        <td title={item.stackTrace} style={{ textAlign: 'center', cursor: item.stackTrace ? 'help' : 'default', fontSize: '14px' }}>
          {item.stackTrace ? '⚠' : '-'}
        </td>
      </tr>
    );
  }
}


class ErrorSongConnector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      searchTerm: "",
      date: new Date()
    };
    storeService.reload();
    this.mounted = true;
    this.loadData(this);
    this.sendDelete = this.sendDelete.bind(this);
    this.searchUpdated = this.searchUpdated.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDayChange = this.handleDayChange.bind(this);
    this.deleteAll = this.deleteAll.bind(this);
  }
  handleDayChange(day) {
    let self = this;
    self.setState({ loading: true })
    this.setState({ date: day });
    errorSongService.getWithFilter(
      day
    ).then(function (data) {
      self.props.reloadErrorSongs(data);
      self.setState({
        loading: false
      })
    });
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  searchUpdated(term) {
    this.setState({ searchTerm: term });
  }
  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value });
  }
  deleteAll() {
    let self = this;
    let dataArr = self.props.data;
    let arrLength = (dataArr)?dataArr.length : 0;

    errorSongService.deleteAll().then(
      function (data) {
        self.context.getNotificationSystem().addNotification({
          message:
            "Se han eliminado " + arrLength + " registros de errores.",
          level: "success"
        })
      }
    )
  }

  deleteError(id) {
    let self = this;
    errorSongService.deleteById(id).then(
      function (data) {
        errorSongService.reload();
        self.context.getNotificationSystem().addNotification({
          message:
            "Se han eliminado el errores.",
          level: "success"
        })
      }
    )
  }


  sendDelete() {
    let self = this;
    errorSongService.deleteById(this.props.item.id).then(function(data) {
      errorSongService.reload();
      self.context.getNotificationSystem().addNotification({
        message:
          "Se ha eliminado exitosamente el error: ",
        title: "Error Eliminada",
        level: "success"
      });
      self.toogleDelete();
    });
  }

  loadData(self) {
    errorSongService
      .getWithFilter(this.state.date)
      .then(function (data) {
        if (!data.hasOwnProperty("error")) {
          self.props.reloadErrorSongs(data);
        }
        if (self.mounted)
          self.setState({
            loading: false
          });
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  render() {
    let data = this.props.data;
    let user = this.props.user.user
    let date = this.state.date;
    let company = this.state.company;
    let filtered = data;
    if (company) {
      filtered = filtered.filter(x => company === x.companyId);
    }
    return (
      <div className="animated fadeIn">
        <Card>
          <CardHeader>
            <div className="d-sm-flex w-100 justify-content-between">
              <CardTitle className="mb-0">Tiendas</CardTitle>
              {user.role === "ADMIN" && (
                <h6 className="mb-1">
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>Compañia</InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="select"
                      id="company"
                      value={company}
                      onChange={this.handleChange}
                    >
                      <option value="">Cualquier Compañia</option>
                      {this.props.companies.map((e, i) => {
                        return (
                          <option key={i} value={e.id}>
                            {e.name}
                          </option>
                        );
                      })}
                    </Input>
                  </InputGroup>
                </h6>
              )}

              <Col sm="4" className="d-sm-inline-block">
                <InputGroup className="mb-2">
                  <DayPickerInput
                    placeholder={moment(date).format("DD/MM/YY")}
                    onDayChange={day => this.handleDayChange(day)}
                    formatDate={formatDate}
                    parseDate={parseDate}
                    inputProps={{ className: "form-control" }}
                    dayPickerProps={{
                      locale: "es",
                      localeUtils: MomentLocaleUtils
                    }}
                  />
                </InputGroup>
              </Col>
              <h6 className="mb-1">
                <div className="card-header-actions">
                  <Button
                    onClick={this.deleteAll}
                    className="btn btn-default btn-sm float-right"
                  >
                    Eliminar datos
                  </Button>
                </div>
              </h6>
            </div>
          </CardHeader>
          <Search
            table={true}
            Thead={TableHead}
            data={filtered}
            ObjectTemplate={ErrorSong}
            loading={this.state.loading}
            bordered={false}
            striped={false}
            viewButton={user.role === "ADMIN"}
          />
        </Card>
      </div>
    );
  }
}


ErrorSongConnector.contextTypes = {
  getNotificationSystem: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.errorSongs,
    companies: state.companies,
    user: state.user,
    channels: state.channels,
    zones: state.zones,
    brands: state.brands,
    stores: state.stores
  };
};

const mapDispatchToProps = dispatch => {
  return {
    reloadErrorSongs: errorSongs => dispatch(reloadErrorSongs(errorSongs))
  };
};

const ErrorSongs = connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorSongConnector);

export default ErrorSongs;
